import { tv } from 'tailwind-variants';

const containerStyle = tv({
  base: 'grid gap-x-2 px-3 relative h-8 transition-all duration-200',
  variants: {
    design: {
      bordered: 'border border-gray-200',
      admin: 'bg-zinc-100 rounded',
      external: 'bg-zinc-100 rounded',
      trader:
        'bg-white border border-gray-200 rounded-lg hover:border-gray-400',
      unbordered: 'border-none',
    },
    size: {
      sm: 'h-7 rounded-md',
      md: 'h-8',
      lg: 'h-10',
    },
    iconPosition: {
      left: 'grid-cols-[auto_1fr] items-center',
      right: 'grid-cols-[1fr_auto] items-center',
    },
    errored: {
      true: 'border border-primary-two',
    },
    disabled: {
      true: '',
    },
  },
  defaultVariants: {
    design: 'bordered',
    sizes: 'md',
  },
  compoundVariants: [
    {
      design: 'trader',
      disabled: true,
      className: 'bg-zinc-50 hover:border-gray-200',
    },
  ],
});

const labelStyles = tv({
  base: 'inline-flex text-sm mb-1 gap-x-1 relative',
  variants: {
    design: {
      admin: 'text-secondary-one',
      external: 'text-secondary-one',
      trader: 'text-primaryFixxer-one font-medium font-inter',
    },
    errored: {
      true: 'text-primary-two',
    },
  },
  defaultVariants: {
    design: 'admin',
  },
});

const iconStyle = tv({
  base: 'text-secondary-two',
  variants: {
    errored: {
      true: 'text-primary-two',
    },
  },
});

export const fieldBaseStyles = {
  container: containerStyle,
  icon: iconStyle,
  label: labelStyles,
};
